<template>
    <MyToolbarBase>
        <div class="btn-group mr-2" role="group" aria-label="First group">
            <button type="button" class="btn " :class="getClass_NoSelect" v-if="configDefault.Add.Enable" @click="btnAdd_Click(configDefault.Add.CallBack)"><i class="fa fa-plus-circle"></i> {{configDefault.Add.BtnText}}</button>
            <button type="button" class="btn " :class="getClass_SingleSelect" v-if="configDefault.Edit.Enable" @click="btnEdit_Click(configDefault.Edit.CallBack)"><i class="fa fa-pen"></i> {{configDefault.Edit.BtnText}}</button>
            <button type="button" class="btn " :class="getClass_MustSelect_Delete" v-if="configDefault.Delete.Enable" @click="btnDelete_Click(configDefault.Delete.CallBack)"><i class="fa fa-trash"></i> {{configDefault.Delete.BtnText}}</button>
            <button type="button" class="btn " :class="getClass_SingleSelect" v-if="configDefault.Copy.Enable"><i class="fa fa-clone"></i> {{configDefault.Copy.BtnText}}</button>
            <button type="button" class="btn " :class="getClass_SingleSelect" v-if="configDefault.CustomButton1.Enable"><i class="fa fa-clone"></i> {{configDefault.CustomButton1.BtnText}}</button>
            <button type="button" class="btn " :class="getClass_SingleSelect" v-if="configDefault.CustomButton2.Enable"><i class="fa fa-clone"></i> {{configDefault.CustomButton2.BtnText}}</button>
            <button type="button" class="btn " :class="getClass_SingleSelect" v-if="configDefault.CustomButton3.Enable"><i class="fa fa-clone"></i> {{configDefault.CustomButton3.BtnText}}</button>
        </div>


        <div class="btn-group " role="group" v-if="configDefault.Export.Enable">
            <button id="btnGroupDrop1" type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{configDefault.Export.BtnText}}
            </button>
            <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                <a class="dropdown-item" href="#">Excel</a>
            </div>
        </div>

        <div class="btn-group mr-2" role="group" aria-label="Second group">
            <button type="button" class="btn btn-primary" v-if="configDefault.Sort.Enable"><i class="fa fa-sort"></i>{{configDefault.Sort.BtnText}}</button>
        </div>


        <div class="btn-group" role="group" aria-label="Third group">
            <button type="button" class="btn btn-primary" v-if="configDefault.Setting.Enable"><i class="fa fa-cog"></i> {{configDefault.Setting.BtnText}}</button>
        </div>
    </MyToolbarBase>
</template>

<script>/**
 <MyGridVuetify  :grid-meta="gridMeta"  >

 <MyToolbarVuetify :config="toolbarVuetifyConfig" :grid-meta="gridMeta" v-on:add-click="btnAdd_Click" v-on:edit-click="btnEdit_Click" v-on:delete-click="btnDelete_Click"></MyToolbarVuetify>

 toolbarVuetifyConfig:{
        Add:{
          Enable:true,
          CallBack:"",
        },
        Edit:{
          Enable:true,
          CallBack:"",
        },
        Delete:{
          Enable:true,
          CallBack:"",
        },
        Copy:{
          Enable:true,
          CallBack:"",
        },
      },

 gridMeta:{},


 toolbarVuetifyConfig:{
        Add:{
          BtnText:"新增",
          Enable:true,
          CallBack:"",
        },
        Edit:{
          BtnText:"修改2",
          Enable:true,
          CallBack:"btnEdit_Click()",
        },
        Copy:{
          Enable:true,
          CallBack:"",
        },
        Sort:{
          Enable:true,
        },
      },
 **/
import util from "@/pages/common/util";
import MyToolbarBase from "@/pages/commonComponent/MyToolbarBase.vue";


export default {
    components: {MyToolbarBase},
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    gridMeta:{
      type: Object,
    },
    config:{
      type: Object,
    },
    addClick: {
      type: Function,
      default() {
        return {}
      }
    },
    editClick: {
      type: Function,
      default() {
        return {}
      }
    },
  },
  data: function () {
    return {
      id: "",
      dataReady: false,
      propsValue: this.value,
      formData: {
        name: "",
      },
      configEnable:{
        SingleSelectFunctionEnable:false,
        NoSelectFunctionEnable:true,
        MustSelectFunctionEnable:false,
      },
      configDefault:{
        Add:{
          BtnText:"新增",
          Enable:false,
          CallBack:"",
        },
        Edit:{
          BtnText:"修改",
          Enable:false,
          CallBack:"",
        },
        Delete:{
          BtnText:"刪除",
          Enable:false,
          CallBack:"",
        },
        Copy:{
          BtnText:"複製",
          Enable:false,//預設不出現
          CallBack:"",
        },
        Export:{
          BtnText:"匯出",
          Enable:false,  //QQ 待完成
          CallBack:"",
        },
        Sort:{
          BtnText:"排序",
          Enable:false, //預設不出現
          CallBack:"",
        },
        Setting:{
          BtnText:"設定",
          Enable:false, //預設不出現
          CallBack:"",
        },
        CustomButton1:{
          BtnText:"",
          Enable:false, //預設不出現
          CallBack:"",
        },
        CustomButton2:{
          BtnText:"",
          Enable:false, //預設不出現
          CallBack:"",
        },
        CustomButton3:{
          BtnText:"",
          Enable:false, //預設不出現
          CallBack:"",
        },
      },

    };
  },
  watch: {
    propsValue(newVal) {
      //this.('input', newVal);
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.propsValue = newVal
    },
    'gridMeta.selectedRecord':function (newValue){
      console.log("gridMeta.selectedRecord",newValue.length);
      // if (newValue) {
        if (newValue.length===0){
          this.configEnable.SingleSelectFunctionEnable=false;
          this.configEnable.NoSelectFunctionEnable=true;
          this.configEnable.MustSelectFunctionEnable=false;
        }else if (newValue.length===1){
          this.configEnable.SingleSelectFunctionEnable=true;
          this.configEnable.NoSelectFunctionEnable=false;
          this.configEnable.MustSelectFunctionEnable=true;
        }else if (newValue.length>1){
          this.configEnable.SingleSelectFunctionEnable=false;
          this.configEnable.NoSelectFunctionEnable=false;
          this.configEnable.MustSelectFunctionEnable=true;
        }
      // }
    }
  },
  computed: {
    getClass_SingleSelect() {
      return {
        'btn-primary': this.configEnable.SingleSelectFunctionEnable,
        'btn-secondary': !this.configEnable.SingleSelectFunctionEnable
      }
    },
    getClass_NoSelect() {
      return {
        'btn-primary': this.configEnable.NoSelectFunctionEnable,
        'btn-secondary': !this.configEnable.NoSelectFunctionEnable
      }
    },
    getClass_MustSelect_Delete() {
      return {
        'btn-danger': this.configEnable.MustSelectFunctionEnable,
        'btn-secondary': !this.configEnable.MustSelectFunctionEnable
      }
    },
  },
  methods: {
    //給予value屬性預設值
    initValue() {
      const isMyObjectEmpty = !Object.keys(this.value).length;

      if (isMyObjectEmpty) {
        let template = {...this.datasDemo};
        this.value = template;
      }
    },
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    btnAdd_Click(code){
      if (code){
        eval(code);
      }else{
        this.$emit('add-click')
      }
    },
    btnEdit_Click(code){
      if (code){
        eval(code);
      }else{
        this.$emit('edit-click',this.gridMeta.selectedRecord[0])
      }
    },
    btnDelete_Click(code){
      if (code){
        eval(code);
      }else{
        this.$emit('delete-click',this.gridMeta.selectedRecord[0])
      }
    },
  },
  mounted() {
    // this.initValue()
    //this.loadData()
    util.ObjectOverride(this.configDefault,this.config);
  },
}
</script>
